import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import {
  FormControl,
  FormGroup,
} from '@angular/forms';
import { Store } from '@ngrx/store';
import {
  DropDownOptions,
  IItemToRequest,
  MyPurchaseForm,
  StoreDropdowns,
} from 'src/app/shared/models/app-models';
import { Subject, lastValueFrom, takeUntil } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { BudgetForm } from '../add-item-page.component';
import { DecimalPipe } from '@angular/common';
import { CurrencyExchange } from 'src/app/shared/models/database-models/CurrencyExchange.model';
import { BackendApiService } from 'src/app/core/services/backend-api';
import { addCurrencyExchange } from 'src/app/core/store/CurrencyExchange.action';
import { getInitialStoreDropdownsCopy } from 'src/app/core/store/dropDown.reducer';

@Component({
  selector: 'app-item-price',
  templateUrl: './item-price.component.html',
  styleUrls: ['./item-price.component.scss'],
  providers: [DecimalPipe]
})
export class ItemPriceComponent implements OnInit, OnDestroy, OnChanges {
  itemPriceQuantity: number = 0;
  itemPriceQuantityPercent: number = 100;
  currencyExchangeError: boolean = false
  @Input() addItemPriceForm!: FormGroup;
  @Input() BudgetForm!: BudgetForm;
  @Input() isReadOnly: boolean = false;
  @Output() currErrorEvent = new EventEmitter<boolean>();
  form: IItemToRequest[] = [];
  // UOM
  UOMdropdown: DropDownOptions[] = [];
  UOMControl!: FormControl;
  isUOMRequired: boolean = false;
  currencyExchangeText: string = ''
  // quantity control
  quantityControl!: FormControl;
  //Currency`
  Currdropdown!: DropDownOptions[];
  CurrencyExchangeInformation: CurrencyExchange[] = []
  CurrControl!: FormControl;
  isCurrRequired: boolean = false;
  StoreDropdownContainer: StoreDropdowns = getInitialStoreDropdownsCopy();

  destroy$: Subject<boolean> = new Subject<boolean>();
  mode: string = 'add';
  itemNo: number = 0;
  totalPrice: string = 'SGD 1.00';
  exchangeRateLock:boolean = false;
  documentStatusId:number=0;
  // dropDownUOM: { title: string; assistive: string; Options: never[]; };
  constructor(
    private store: Store<{ form: MyPurchaseForm; dp: StoreDropdowns, currency: CurrencyExchange[] }>,
    private route: ActivatedRoute,
    private decimalPipe: DecimalPipe,
    private backendService: BackendApiService
  ) {
    this.mode = this.route.snapshot.params['itemNo'] ? 'edit' : 'add';
    if (this.mode === 'edit') {
      this.itemNo = this.route.snapshot.params['itemNo'];
    }

    this.store
      .select('dp')
      .pipe(takeUntil(this.destroy$))
      .subscribe((dp: StoreDropdowns) => {
        this.StoreDropdownContainer = dp;
        this.loadData();
      });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isReadOnly']) {
      if (changes['isReadOnly'].currentValue == true) {
        this.addItemPriceForm.disable();
      } else {
        this.addItemPriceForm.enable();
      }
    }
  }
  loadData() {
    this.UOMdropdown = this.StoreDropdownContainer.UOM;
    this.Currdropdown = this.StoreDropdownContainer.Currency;
  }

  restrictNegativeNumberInput(event: Event, decimalPlaces?: number): void {
    const inputElement = event.target as HTMLInputElement;
    const enteredValue = parseFloat(inputElement.value);
    const numberOfDecimals = enteredValue.toString().split('.')[1]?.length;
    if (!isNaN(enteredValue) && numberOfDecimals > (decimalPlaces ?? 2)) {
      inputElement.value = inputElement.valueAsNumber.toFixed(
        decimalPlaces ?? 2
      );
    }
    if (!isNaN(enteredValue) && enteredValue < 0) {
      inputElement.value = '0';
    }
    if (!isNaN(enteredValue) && enteredValue > 9999999999999.999 && decimalPlaces && decimalPlaces == 3) {
      inputElement.value = '0';
    }
    if (!isNaN(enteredValue) && enteredValue > 9999999999999.99 && decimalPlaces && decimalPlaces == 2) {
      inputElement.value = '0';
    }
  }
  async ngOnInit(): Promise<void> {
    this.UOMControl = this.addItemPriceForm.controls[
      'UnitOfMeasurement'
    ] as FormControl;
    this.quantityControl = this.addItemPriceForm.controls[
      'Quantity'
    ] as FormControl;
    this.store.select('currency').pipe(takeUntil(this.destroy$)).subscribe((currencies: CurrencyExchange[]) => {
      console.log("CURRENCIES", currencies)
      this.CurrencyExchangeInformation = currencies
    })
    this.store
      .select('form')
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (form: MyPurchaseForm) => {
        this.form = form.ItemList;
        this.exchangeRateLock = form.ExchangeRateLock;
        this.documentStatusId = form.documentStatusId;

        if (
          this.mode == 'edit' &&
          this.form.length !== 0 &&
          this.addItemPriceForm
        ) {
          console.log('this form Edit', this.form[this.itemNo - 1].ItemPrice);

          let unitOfMeasurement =
            this.form[this.itemNo - 1].ItemPrice.UnitOfMeasurement.value;
          let currencyCode =
            this.form[this.itemNo - 1].ItemPrice.Currency.value;
          let quantity = this.decimalPipe.transform(this.form[this.itemNo - 1].ItemPrice.Quantity, '1.3-3')?.replaceAll(',', '') || '0.000';
          let unitPrice = this.decimalPipe.transform(this.form[this.itemNo - 1].ItemPrice.UnitPrice, '1.2-2')?.replaceAll(',', '') || '0.000';
          let unitsPerQuantity =
            this.decimalPipe.transform(this.form[this.itemNo - 1].ItemPrice.UnitsPerQuantity, '1.2-2')?.replaceAll(',', '') || '0.000';
          let exchangeRate =
            this.form[this.itemNo - 1].ItemPrice.ExchangeRate;
          if (currencyCode && unitOfMeasurement) {
            let calculatedAmt: any = (this.form[this.itemNo - 1].ItemPrice.Quantity * this.form[this.itemNo - 1].ItemPrice.UnitPrice) / this.form[this.itemNo - 1].ItemPrice.UnitsPerQuantity;
            calculatedAmt = calculatedAmt.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            this.totalPrice = currencyCode + " " + calculatedAmt;
          }
          let item = this.form[this.itemNo - 1].ItemPrice;
          this.addItemPriceForm.setValue({
            UnitOfMeasurement: item.UnitOfMeasurement,
            Quantity: quantity,
            Currency: item.Currency,
            UnitPrice: unitPrice,
            UnitsPerQuantity: unitsPerQuantity,
            ExchangeRate:exchangeRate
          });
          
          this.BudgetForm.Quantity = item.Quantity;
          if (item.Currency && item.UnitOfMeasurement)
            await this.updateCurrencyDisplay(item.Currency.value, this.form[this.itemNo - 1].ItemPrice.Quantity, this.form[this.itemNo - 1].ItemPrice.UnitPrice, this.form[this.itemNo - 1].ItemPrice.UnitsPerQuantity,exchangeRate)
        }
      });
    this.quantityControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((quan) => {
        console.log('called quan', quan);
        this.BudgetForm.Quantity = quan;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  async CalculateEastimateCost(event: any) {
    if (this.addItemPriceForm.controls['UnitsPerQuantity'].value <= 0) {
      this.addItemPriceForm.controls['UnitsPerQuantity'].setValue(1);
    }
    let unitOfMeasurement =
      this.addItemPriceForm.controls['UnitOfMeasurement'].value['value'];
    let currencyCode =
      this.addItemPriceForm.controls['Currency'].getRawValue()?.value;
    let quantity = this.addItemPriceForm.controls['Quantity'].value;
    let unitPrice = this.addItemPriceForm.controls['UnitPrice'].value;
    let unitsPerQuantity =
      this.addItemPriceForm.controls['UnitsPerQuantity'].value;
    if (currencyCode && unitOfMeasurement) {
      if (currencyCode === 'SGD') {
        let calculatedAmt: any = (quantity * unitPrice) / unitsPerQuantity;
        calculatedAmt = calculatedAmt.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        this.totalPrice = currencyCode + ' ' + calculatedAmt;
        this.currencyExchangeError = false
        this.currErrorEvent.emit(false)
      } else {
        await this.updateCurrencyDisplay(currencyCode, quantity, unitPrice, unitsPerQuantity,0)
      }


    }
    if (quantity !== null && quantity !== undefined && quantity !== 0) {
      this.itemPriceQuantity = quantity;
    }
  }
  async updateCurrencyDisplay(currencyCode: string, quantity: number, unitPrice: number, unitsPerQuantity: number,exchangeRateCurrency:number) {
    if (!currencyCode || currencyCode == 'SGD') return
    let currency: CurrencyExchange | undefined = this.CurrencyExchangeInformation.find(x => x.FromCurrency == currencyCode)
    if (!currency) {
      try {
        currency = await this.getCurrencyExchange(currencyCode);
        if (currency) {
          this.store.dispatch(addCurrencyExchange({ currency: currency }))
          this.currencyExchangeError = false
          this.currErrorEvent.emit(false)
        }
      } catch (error) {
        this.currencyExchangeError = true
        this.currErrorEvent.emit(true)
        this.currencyExchangeText = 'No data available'
        this.totalPrice = 'No data available'
      }
    }
    if (currency) {
      this.currencyExchangeError = false
      this.currErrorEvent.emit(false)
      let exchangeRate
      if(this.exchangeRateLock){
        exchangeRate = exchangeRateCurrency;
        }else if(this.documentStatusId === 2 || this.documentStatusId === 3 || this.documentStatusId === 6){
          exchangeRate = currency!.Rate;
        }else{
          exchangeRate = exchangeRateCurrency;
      }
      // let exchangeRate: number = currency!.Rate
      let ratio: number = currency.RatioForTheFromCurrencyUnits
      console.log("exchangeRate", exchangeRate)
      console.log("currencyCode", currencyCode)
      let calculatedAmt: any = (quantity * unitPrice * (exchangeRate / ratio)) / unitsPerQuantity;
      calculatedAmt = calculatedAmt.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      let foreignCalculatedAmt: any = (quantity * unitPrice) / unitsPerQuantity;
      foreignCalculatedAmt = foreignCalculatedAmt.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      this.totalPrice = `${currencyCode} ${foreignCalculatedAmt} = SGD ${calculatedAmt}`
      this.currencyExchangeText = currencyCode + ' 1 = SGD ' + exchangeRate
    }
  }
  async getCurrencyExchange(currency: string) {
    console.log("currency", currency)
    const resp: CurrencyExchange = await lastValueFrom(this.backendService.getCurrencyExchange(currency));
    return resp;
  }
}
